export const branchCodes = `[
  {
    "warehouseId": "EN-MW",
    "siteId": "ENF",
    "name": "Enfield",
    "sgId": "d6e0f549-2461-4f52-bd14-14aea27e124c"
  },
  {
    "warehouseId": "SD-MW",
    "siteId": "SID",
    "name": "Sidcup",
    "sgId": "c0deb77f-8f6a-41e9-ac35-e7876aa87f0a"
  },
  {
    "warehouseId": "AS-MW",
    "siteId": "AST",
    "name": "Aston",
    "sgId": "e29b9bf6-058c-4a5e-8e78-4814d4c08f99"
  },
  {
    "warehouseId": "BR-MW",
    "siteId": "BRI",
    "name": "Bristol",
    "sgId": "089075b7-d2b3-4ea9-8788-f29755a991e8"
  },
  {
    "warehouseId": "BS-MW",
    "siteId": "BAS",
    "name": "Basingstoke",
    "sgId": "314969fb-3d0a-4801-9c1d-8defe27af176"
  },
  {
    "warehouseId": "DN-MW",
    "siteId": "DON",
    "name": "Doncaster",
    "sgId": "9fbe267f-a1ed-47e6-b7ce-1203782f70bb"
  },
  {
    "warehouseId": "LD-MW",
    "siteId": "LDS",
    "name": "Leeds",
    "sgId": "e3f8d1ba-e605-4909-bb64-ed861087aa36"
  },
  {
    "warehouseId": "MN-MW",
    "siteId": "MAN",
    "name": "Manchester",
    "sgId": "84eb8e30-d990-49d0-ab6f-5e8ca90ecac9"
  },
  {
    "warehouseId": "DG-MW",
    "siteId": "DAG",
    "name": "Dagenham",
    "sgId": "968987bd-db62-4d05-b794-6a76b80afb88"
  },
  {
    "warehouseId": "LS-MW",
    "siteId": "LST",
    "name": "Leicester",
    "sgId": "147eae4a-ce2b-403e-b229-3b2eb257087d"
  },
  {
    "warehouseId": "NC-MW",
    "siteId": "NEW",
    "name": "Newcastle",
    "sgId": "66a6d228-e703-42bd-998c-f3b5c6f1cdbc"
  },
  {
    "warehouseId": "WB-MW",
    "siteId": "WBD",
    "name": "Wimbledon",
    "sgId": "88e0ca01-7296-467e-82f2-9336ad2b29e1"
  }
]`

export const getBranchNames = () =>
    ['All', ...JSON.parse(branchCodes).map(b => b.name)];

export const getBranchFromGroups = (userGroups) => {
    const parsed = JSON.parse(branchCodes);
    const match = parsed.find(b => userGroups.includes(b.sgId));
    return match?.name ?? 'All';
};